export default __webpack_public_path__ + "static/residential-interior-demolition-icon-7b77e219685406f4da68a0e5c181e5bc.png";